/**
 * 退出登录封装：Dropdown「退出登录」触发 Modal.confirm，确认后 authApi.logout + 清空上下文 + 重定向登录页。
 * 对齐原型 `prototype/admin/src/layout/AdminLayout.tsx:72-83` 文案。
 * modal 经 App.useApp() 获取，消费 ConfigProvider 动态主题（AntD 5 静态 Modal.confirm 不消费主题）。
 * 覆盖 admin-web-shell:SC-03。
 */
import { useNavigate } from 'react-router-dom';
import { authApi } from '../api/auth.api';
import { useDraggableModal } from '../components/useDraggableModal';
import { useSession } from './SessionContext';

export function useLogout() {
  const navigate = useNavigate();
  const { logout } = useSession();
  const modal = useDraggableModal();

  return function confirmLogout() {
    modal.confirm({
      title: '确认退出登录？',
      content: '退出后需重新登录才能继续使用管理端。',
      okText: '退出',
      cancelText: '取消',
      onOk: async () => {
        try {
          await authApi.logout();
        } catch {
          // 桩：退出失败不阻塞清空本地会话（真实后端在 2-2）
        }
        logout();
        navigate('/login', { replace: true });
      },
    });
  };
}
